import { useEffect, useState } from 'react';
import { Box, Flex, Spinner, Image } from '@chakra-ui/react';
import { HiOutlineCube } from 'react-icons/hi';


export default function ImageDisplayWithLoader({ imageUrl, altText, width, height, border, borderColor, rounded }) {
  
  const [imageIsLoading, setImageIsLoading] = useState(true);
  const [clickCount, setClickCount]= useState(0);
  const [displayedImage, setDisplayedImage] = useState(null);

  useEffect(() => {
    if (imageUrl) {
      setDisplayedImage(imageUrl)
      setClickCount(prevCount => prevCount + 1)
    }
  }, [imageUrl])

  if (imageUrl) {
    return (
      <Box width={width} height={height} bg='white' border={border} borderColor={borderColor} rounded={rounded} overflow='hidden'>
        {imageIsLoading &&
          <Flex alignItems='center' justify='center' w='100%' h='100%'>
            <Spinner
              thickness="3px"
              speed="0.65s"
              emptyColor="gray.200"
              color="brand.500"
              boxSize="2em"
              zIndex='10'
            />
          </Flex>
        }
        <Flex justify='center' alignItems='center' height='100%'>
          <Image key={`user-profile-pic-${clickCount}`} src={displayedImage} objectFit="cover" alt={altText} visibility={imageIsLoading ? 'hidden' : ''} onLoad={() => setImageIsLoading(false)} />
        </Flex>
      </Box>
    )
  }

  if (!displayedImage) {
    return (
      <Flex w='100%' width={width} height={height ? height : 'inherit'} bg='gray.300' justify='center' alignItems='center' rounded='0.5em'>
        <HiOutlineCube size={40} color="white" />
      </Flex>
    )
  }
}
